/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {RecaptchaCommonModule as ɵa} from './lib/recaptcha-common.module';